import { Marketings } from "pages/Home/core/home.types";
import { IProps } from "./modalConfig.types";
import { NavigateFunction } from "react-router-dom";
import { carryUtmSource } from "utils";

export const onRestaurantSelect = (
  restaurant: any,
  navigate: NavigateFunction,
  campaignId: string
) => {
  carryUtmSource(campaignId, restaurant.cid);
  navigate(`/${restaurant.cid}`);
};

export const getNumberOfSteps = (marketing: IProps["marketing"]): any => {
  switch (marketing) {
    case Marketings.newsletter:
      return 4;
    case Marketings.googlePlace:
      return 2;
    default:
      return 1;
  }
};
